import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import favoritesModalReducer from 'containers/PageHeader/FavoritesModal/reducer';
import createGroupModalReducer from 'containers/PageHeader/Groups/store/reducer';
import exportModalReducer from 'containers/PageHeader/ExportModal/reducer.ts';
import accessControlReducer from 'containers/AccessControl/reducer';
import accessControlSagas from 'containers/AccessControl/sagas';
import pageHeaderReducer from 'containers/PageHeader/reducer';
import createEditCampaignModalReducer from 'containers/Campaigns/CreateEdit/store/reducer';
import createEditCampaignSagas from 'containers/Campaigns/CreateEdit/store/sagas';
import campaignsReducer from 'containers/Campaigns/reducer';
import campaignsSagas from 'containers/Campaigns/sagas';
import groupsReducer from 'containers/Groups/reducer';
import filterModalReducer from 'components/FilterModal/store/reducer';
import portfolioPageHeaderReducer from 'containers/Portfolio/PageHeader/reducer';
import globalReducer from 'store/global/reducer';
import ReactGA from 'react-ga';
import eventTracking from 'utils/events';
import createEditCGroupSagas from 'containers/PageHeader/Groups/store/sagas';

const sagaMiddleware = createSagaMiddleware();

const trackEvent = (properties, payload) => {
  const label = {
    label: typeof payload === 'object' ? JSON.stringify(payload) : payload.toString(),
  };
  const event = { ...properties, ...label };

  ReactGA.event(event); // Track event to google analytics
};

const trackingMiddleware = (store) => (next) => (action) => {
  if (eventTracking[action.type]) {
    if (action.type === 'PageHeader/global-filter-arrays-update') {
      let filterArray = [];
      action.payload.newFilter.accounts.length > 0 && filterArray.push('accounts');
      action.payload.newFilter.items.length > 0 && filterArray.push('items');
      action.payload.newFilter.states.length > 0 && filterArray.push('states');
      action.payload.newFilter.stores.length > 0 && filterArray.push('stores');

      const customPayload = {
        filteringOn: action.payload.globalFilterKey,
        filteringThrough: filterArray,
      };

      trackEvent(eventTracking[action.type], customPayload);
    } else if (action.type === 'PageHeader/global-filter-array-update') {
      trackEvent(eventTracking[action.type], action.payload.arrayName);
    } else {
      trackEvent(eventTracking[action.type], action.payload ? action.payload : '');
    }
  }

  return next(action);
};

const reducers = combineReducers({
  global: globalReducer,
  createGroupModal: createGroupModalReducer,
  exportModal: exportModalReducer,
  favoritesModal: favoritesModalReducer,
  accessControl: accessControlReducer,
  pageHeader: pageHeaderReducer,
  campaigns: campaignsReducer,
  createEditCampaign: createEditCampaignModalReducer,
  groups: groupsReducer,
  filterModalReducer: filterModalReducer,
  portfolioPageHeader: portfolioPageHeaderReducer,
});

let composeEnhancers = compose;
if (process.env.NODE_ENV === 'development') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const configureStore = () => {
  const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(sagaMiddleware, trackingMiddleware))
  );
  [accessControlSagas, createEditCampaignSagas, campaignsSagas, createEditCGroupSagas].map((saga) =>
    sagaMiddleware.run(saga)
  );
  return store;
};

export default configureStore;
